import React from "react";
import RecursosPhoto from "../../../images/landing/newphotos/recursos-entrega.jpg";
import "./style.css";
import "../../landing.css";
import localeText from "../../../../locale";

const resources = [
  { icon: "pi pi-map-marker", title: "lp2RecursosItem1Title", description: "lp2RecursosItem1Desc" },
  { icon: "pi pi-users", title: "lp2RecursosItem2Title", description: "lp2RecursosItem2Desc" },
  { icon: "pi pi-shield", title: "lp2RecursosItem3Title", description: "lp2RecursosItem3Desc" },
  { icon: "pi pi-search", title: "lp2RecursosItem4Title", description: "lp2RecursosItem4Desc" },
];

const LandingExclusiveSection = () => {
  return (
    <section className="full-width bg-white py-8" id="resources">
      <div className="grid align-items-center">
        <div className="col-12 lg:col-6 py-4 flex flex-column gap-3 pr-0 lg:pr-6">
          <div className="eyebrow-text">{localeText("lp2RecursosEyebrow")}</div>
          <div
            className="font-bold text-4xl md:text-5xl line-height-2 title"
            style={{ color: "var(--extra-green)" }}
          >
            {localeText("lp2RecursosTitle")}
          </div>
          <div className="text-lg mb-2" style={{ color: "var(--extra-body)" }}>
            {localeText("lp2RecursosDescription")}
          </div>
          <div>
            {resources.map((resource, index) => (
              <div
                key={resource.title}
                className="flex gap-3 py-3"
                style={{
                  borderTop: index === 0 ? "none" : "1px solid var(--extra-line)",
                }}
              >
                <i
                  className={resource.icon}
                  style={{ color: "var(--extra-green)", fontSize: "1.4rem", marginTop: "2px" }}
                ></i>
                <div>
                  <div className="font-bold text-lg" style={{ color: "var(--extra-ink)" }}>
                    {localeText(resource.title)}
                  </div>
                  <div className="text-sm mt-1" style={{ color: "var(--extra-body)" }}>
                    {localeText(resource.description)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="col-12 lg:col-6">
          <div
            className="recursos-photo relative"
            style={{ backgroundImage: `url(${RecursosPhoto})` }}
            role="img"
            aria-label="Foto de duas mulheres trocando uma caixa de brinquedos de pelúcia na rua"
          >
            <div
              className="card recursos-card-left absolute m-0 border-round-lg border-none text-white"
              style={{ top: "8%", backgroundColor: "rgba(44, 107, 71, 0.95)" }}
            >
              <div className="font-bold text-2xl title">€ 120,00</div>
              <div className="text-xs opacity-75">{localeText("lp2RecursosCashbackLabel")}</div>
            </div>
            <div
              className="card recursos-card-right absolute m-0 border-round-lg border-none text-white"
              style={{ bottom: "8%", backgroundColor: "rgba(44, 107, 71, 0.95)" }}
            >
              <div className="font-bold text-2xl title">€ 120,00</div>
              <div className="text-xs opacity-75">{localeText("lp2RecursosLocalSaleLabel")}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingExclusiveSection;
